import { useLocale } from "next-intl";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export function useLocalizedQuery<T>({
  queryKey,
  queryFn,
  options,
}: {
  queryKey: readonly unknown[];
  queryFn: (lang: string) => Promise<T>;
  options?: Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;
}) {
  const locale = useLocale();

  const result = useQuery({
    queryKey: [...queryKey, locale],
    queryFn: () => queryFn(locale),
    ...options,
  });

  if (result.isError) {
    throw result.error;
  }

  return result;
}
